<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col d-flex justify-content-center align-items-center vh-100">
                    <h1 class="text-secondary">
                        403, FORBIDDEN
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>
